import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  loadCampaignDetailPage,
  unloadCampaignDetailPage,
  bulkSendSMSViaCampaign
} from "../../redux/actions/asset.actions";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import * as DateHelper from "../../utils/date.formatter";
import { REACT_APP_MODE } from "../../config";
import CampaignItemList from "../../components/CampaignItemList";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";
import constants from "../../constants";

function Campaign({}) {
  let { key } = useParams();
  const asset = useSelector(state => state.asset);
  const common = useSelector(state => state.common);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadCampaignDetailPage(key));
    return () => dispatch(unloadCampaignDetailPage());
  }, [key]);

  const handleSendSMS = () => ev => {
    ev.preventDefault();
    if (window.confirm(i18n.t("campaign.send_sms_to_all_confirm_msg"))) {
      dispatch(bulkSendSMSViaCampaign(key));
    }
  };
  if (!asset.campaign) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"campaigns"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  const campaign = asset.campaign;
  const exception_items =
    campaign.items &&
    campaign.items.filter(
      p => p.client === constants.campaign_item_response_status
    );
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"campaigns"} />
          <div id="content">
            <Header />
            <div className="content-wrap">
              <div className="box-header">
                <Link
                  className="header-button"
                  to={`/campaigns/${campaign.key}/edit`}
                >
                  {t("campaign.edit_campaign_button")}
                </Link>
                <Link className="header-button" to={`/sites/${campaign.site}`}>
                  {campaign.site_name}
                </Link>
                <h2>{campaign.name}</h2>
              </div>
              <ul className="dashboard-list">
                <li>
                  <strong>{t("common.assets")}</strong>
                  <em>{campaign.items.length}</em>
                </li>
                <li>
                  <strong>{t("common.status")}</strong>
                  <em>
                    {t("campaign.status_" + campaign.status.toLowerCase())}
                  </em>
                </li>
                <li>
                  <strong>{t("common.created")}</strong>
                  <em>{DateHelper.toLocalString(campaign.created)}</em>
                </li>
              </ul>
              <hr className="break" />
              <div className="box-sms-message">
                <strong>{t("campaign.label_sms_message")}:</strong>
                {campaign.notes}
                <em>https://iso.pellar.io/ISOLATION_ID</em>
              </div>
            </div>
            {exception_items && exception_items.length > 0 ? (
              <div className="content-wrap">
                <div className="box-header">
                  <h2>{t("campaign.items_title_flagged")}</h2>
                </div>
                <CampaignItemList data={campaign.exception_items} />
              </div>
            ) : null}

            <div className="content-wrap">
              <div className="box-header">
                <Link
                  className="header-button"
                  to={`/campaigns/${campaign.key}/items/edit`}
                >
                  {t("campaign.edit_items_button")}
                </Link>
                <a className="header-button" onClick={handleSendSMS()}>
                  {common.inProgress
                    ? t("system.sending_feeback")
                    : t("campaign.send_sms_to_all_button")}
                </a>
                <h2>{t("campaign.items_title")}</h2>
              </div>
              <CampaignItemList data={campaign.items} />
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Campaign;
